import { Component, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocalizationPipe } from '@abp/ng.core';
import { COLUMN_HEADER_KEYS, STEP_INFO } from './step-inventory-validation.config';
import { IStepDataItem } from '../interfaces/IStepDataItem';
import { IWizardContext, IWizardStepState, WizardStepComponent } from '@zendra/shared';
import {
  buildPreviousStepMeta,
  getPreviousStepData,
  persistStepData,
  shouldReuseCurrentStepData,
} from '../helpers/harvest-preparation.helpers';

@Component({
  selector: 'lib-step-inventory-validation',
  standalone: true,
  imports: [FormsModule, LocalizationPipe],
  templateUrl: './step-inventory-validation.html',
})
export class StepInventoryValidation implements WizardStepComponent {
  readonly localizationKeyPrefix = STEP_INFO.localizationKeyPrefix;
  readonly columnHeaderKeys = COLUMN_HEADER_KEYS;

  loading = signal(false);
  rows = signal<IStepDataItem[]>([]);
  
  allInventoryValidated = computed(() =>
    this.rows().length > 0 && this.rows().every(row => !!row.isInventoryValidated),
  );

  onToggleAllInventoryValidated(isValidated: boolean): void {
    this.rows.update(rows => {
      rows.forEach(row => {
        row.isInventoryValidated = isValidated;
      });

      return [...rows];
    });
  }

  onActivate(context: IWizardContext): void {

    const state = context.getStepState<IStepDataItem[]>(
      context.activeStepId(),
    ) as IWizardStepState<IStepDataItem[]>;
    const previousStepData = getPreviousStepData(context);

    if (shouldReuseCurrentStepData(state, previousStepData)) {
      this.rows.set(state?.data ?? []);
      return;
    }

    this.rows.set(previousStepData);
  }

  collect(context: IWizardContext): IStepDataItem[] {
    const data = persistStepData(context, {
      data: this.rows(),
      completed: true,
      valid: true,
      meta: buildPreviousStepMeta(context),
      invalidateNextSteps: false,
    });
    return data;
  }
}
